import { log } from "../../../engine/logger/logger";
import { closeModal } from "../../../ui/containers/Modal";
import { floodFill } from "../../../ui/helpers";
import { TextType } from "../../../ui/type/TextType";
import { ComponentF, ComponentO, createElement } from "../../../ui/ui";
import { createAction } from "../../actions/Action";
import { useItem } from "../../actions/ActionItems";
import Colors from "../../Colors";
import { gameData, runPlayerAction } from "../../GameManager";
import { items } from "../../items/itemsTypes";
import { isDownKey, isUpKey } from "../keyHelper";
import { ItemInfoDisplay } from "./ItemInfoDisplay";

export const UseModal: ComponentF<{
  onItemSelected: (id: string) => void;
}> = (C, props) => {
  const [state, setState] = C.useState({ selected: 0, id: null });

  floodFill(C.display, C.bounds, Colors.BLACK);
  let y = 0;

  C.display.draw(
    C.bounds.x,
    C.bounds.y + y + state.selected,
    ">",
    Colors.B_GREY_5,
    null
  );
  const result: ComponentO[] = [];

  const ids: number[] = [];
  gameData.player.contains.forEach((item, index) => {
    if (item.breed.usable != null) {
      ids.push(item.id);
      result.push(
        createElement(
          TextType,
          { x: 1, y, w: 20, h: 1 },
          {
            title: `%c{${
              state.selected === index ? Colors.B_GREY_5 : Colors.B_GREY_3
            }}${item.breed.name}`,
          }
        )
      );
      if (index === state.selected) {
        result.push(
          createElement(
            ItemInfoDisplay,
            {
              x: 30,
              y: 0,
              w: C.bounds.w - 31,
              h: C.bounds.h - 1,
            },
            { item }
          )
        );
      }
      y += 1;
    }
  });

  C.handlers.keypress = (key: string) => {
    if (isUpKey(key) && 0 < state.selected) {
      setState({ selected: state.selected - 1 });
    } else if (isDownKey(key) && state.selected < ids.length - 1) {
      setState({ selected: state.selected + 1 });
    } else if (key === "Enter") {
      const item = gameData.player.contains.get(ids[state.selected]);
      if (item?.uses?.current) {
        runPlayerAction(
          createAction(useItem, gameData.player, { id: ids[state.selected] })
        );
      } else if (item) {
        log(`No uses remaining for ${item.breed.logName}`);
      }
      closeModal();
      return true;
    } else if (key === "Escape") {
      closeModal();
      return true;
    }
    return true;
  };
  return result;
};
